import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {setTokenByName} from '@/system/store/cookie';

export function login(userInfo){
	const data = request({
		url: config.url+'login',
		method: 'post',
		data: userInfo
	});
	
	var result = Promise.resolve(data);
	
	result.then(function(value){
		if(value.valid){
			setTokenByName('auth_sign_token', value.token, 3);
		}
	});
	
	return Promise.resolve(data);
}

export function getLogin(){
	
	const data = request({
		url: config.url+'login',
		method: 'get'
	});
	
	return Promise.resolve(data);
}